import { RefreshIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { Button, ButtonProps } from '@va/ui/design-system';
import classNames from 'classnames';

type RefreshButtonV2Props = ButtonProps & {
  refreshFn: () => void;
};

export const RefreshButton = ({ refreshFn, className, ...buttonProps }: RefreshButtonV2Props) => {
  const translate = useTranslate();
  return (
    <Button
      icon={() => <RefreshIcon className='sm:w-18px sm:h-18px' />}
      color='secondary'
      onClick={() => {
        refreshFn();
      }}
      tooltip={translate('card.button.refresh')}
      className={classNames('sm:h-9 sm:w-9 sm:p-2 rounded-lg', className)}
      {...buttonProps}
    />
  );
};
